import { ActionTypes } from "./types";
import { retentionsTypeLabels, retentionsStatusLabels } from "helpers/retentionsDictionary";

const {
  SET_RETENTION_OUTPUTS,
  ADD_RETENTION_OUTPUT,
  UPDATE_RETENTION_OUTPUT,
  REMOVE_RETENTION_OUTPUT,
  SET_FILTERS,
  CLEAR_RETENTION_OUTPUTS,
  RESTORE_INITIAL,
} = ActionTypes;

const now = new Date();
const currentMonth = now.getMonth() + 1;
const currentYear = now.getFullYear();

const INITIAL_STATE = {
  retentionOutputs: [],
  station: null,
  month: currentMonth,
  year: currentYear,
};

export const retentionOutputsReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case SET_RETENTION_OUTPUTS:
      const retentionOutputs = payload.map((item) => ({
        ...item,
        statusLabel: retentionsStatusLabels[item.status],
        typeLabel: retentionsTypeLabels[item.type],
      }));

      return { ...state, retentionOutputs };

    case ADD_RETENTION_OUTPUT:
      const newRetentionOutput = {
        ...payload,
        statusLabel: retentionsStatusLabels[payload.status],
        typeLabel: retentionsTypeLabels[payload.type],
      };
      return { ...state, retentionOutputs: [newRetentionOutput, ...state.retentionOutputs] };

    case UPDATE_RETENTION_OUTPUT:
      return {
        ...state,
        retentionOutputs: state.retentionOutputs.map((item) =>
          // uploadEvidence solo manda { id, urlEvidence }: sin status se conserva el del renglón
          item.id === payload.id
            ? {
                ...item,
                ...payload,
                status: payload.status ?? item.status,
                statusLabel: retentionsStatusLabels[payload.status ?? item.status],
              }
            : item
        ),
      };

    case REMOVE_RETENTION_OUTPUT:
      return {
        ...state,
        retentionOutputs: state.retentionOutputs.filter((item) => item.id !== payload),
      };

    case SET_FILTERS: {
      let retentionOutputs = state.retentionOutputs;
      if (payload.key === "station") retentionOutputs = [];
      return { ...state, [payload.key]: payload.value, retentionOutputs };
    }

    case CLEAR_RETENTION_OUTPUTS:
      return { ...state, retentionOutputs: [] };

    case RESTORE_INITIAL:
      return INITIAL_STATE;

    case "CLOSE_SESSION_LOGIN":
      return INITIAL_STATE;

    default:
      return state;
  }
};
